import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from './components/Header';
import Home from './pages/Home'
import Messaggi from './pages/Messaggi'
import Lista from './pages/Lista'
import Login from './pages/Login'
import RSVP from './pages/RSVP'
import Cerimonia from './pages/Cerimonia'
import Upload from './pages/Upload'
import InvitatiPage from './pages/Invitati'

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { CookiesProvider } from 'react-cookie'
import { useAuth, AuthProvider } from "./auth/auth";
import Ricevimento from './pages/Ricevimento';
import { ParallaxProvider } from 'react-scroll-parallax';

const theme = createTheme({
  palette: {
    primary: {
      //main: "#fd69a0"
      // lavanda fod: #d2c3d6
      main: "#8F9779"
      //"#FFBFD6"
      //#FFBFD6
    }, 
    secondary: {
      main: "#646954"
    },
  },
});

function CompleteRSVP(props) {
  const { cb } = props;
  cb(true);
  return (
    <Navigate to="/rsvp?completed=true" />
  )
}

function App() {

  const completed = window.localStorage.getItem("completed");

  function handleCookies(v) {
    window.localStorage.setItem("completed", v);
  }

  return (
    <ThemeProvider theme={theme}>
      <ParallaxProvider>
      <AuthProvider>
        <CookiesProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Header completed={completed} />}>
                <Route index element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="/cerimonia" element={<ProtectedRoute><Cerimonia /></ProtectedRoute>} />
                <Route path="/ricevimento" element={<ProtectedRoute><Ricevimento /></ProtectedRoute>} />
                <Route path="/rsvp" element={<ProtectedRoute><RSVP isDone={completed} /></ProtectedRoute>} />
                <Route path="/rsvp_done" element={<ProtectedRoute><CompleteRSVP cb={handleCookies} /></ProtectedRoute>} />
                <Route path="/lista" element={<ProtectedRoute><Lista /></ProtectedRoute>} />
                <Route path="/messaggi" element={<ProtectedRoute><Messaggi /></ProtectedRoute>} />
                <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<InvitatiRoute><InvitatiPage /></InvitatiRoute>} />
                <Route path="*" element={<ProtectedRoute><Cerimonia /></ProtectedRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CookiesProvider>
      </AuthProvider>
      </ParallaxProvider>
    </ThemeProvider>
  );
}

const LIMIT = 90 * 60 * 1000;

const ProtectedRoute = ({ children }) => {
  const { user, login } = useAuth();
  //console.log(user);
  if (!user) {
    // user is not authenticated
    return <Navigate to={"/login?redirect=" + window.location.pathname} />;
  }
  const hb = window.localStorage.getItem("hb");
  // check last interaction < 1h
  //console.log(Date.now() - hb)
  if(Math.abs(Date.now() - hb) > LIMIT) {
    login(null); // logout
    return null;
  }
  window.localStorage.setItem("hb", Date.now());
  return children;
};

const InvitatiRoute = ({ children }) => {
  // const user = localStorage.getItem("giorgia");
  // if (user !== "mylove") {
  //   // user is not authenticated
  //   return <Navigate to="/" />;
  // }
  return children;
};


export default App;
